<template>
  <v-card outlined class="referral-link-card mb-4">
    <div class="referral-link-card__inner">
      <div class="referral-link-card__icon">
        <v-icon color="#e5183d">mdi-link-variant</v-icon>
      </div>
      <div class="referral-link-card__content">
        <strong class="referral-link-card__title">Link de indicação</strong>
        <p class="referral-link-card__subtitle">
          Compartilhe com quem deseja entrar na sua rede. O cadastro já entra aprovado.
        </p>
        <div v-if="loading" class="referral-link-card__loading">
          <v-progress-linear indeterminate color="#e5183d" height="3" />
        </div>
        <template v-else-if="link">
          <div class="referral-link-card__field">
            <code class="referral-link-card__url">{{ link.url }}</code>
            <v-btn
              small
              color="#e5183d"
              dark
              class="referral-link-card__copy"
              @click="copyLink"
            >
              <v-icon left small>{{ copied ? "mdi-check" : "mdi-content-copy" }}</v-icon>
              {{ copied ? "Copiado" : "Copiar" }}
            </v-btn>
          </div>
          <span class="referral-link-card__code">Código: {{ link.code }}</span>
        </template>
        <p v-else class="referral-link-card__error">Não foi possível carregar o link de indicação.</p>
      </div>
    </div>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { GetMyReferralLink, MyReferralLinkType } from "@/services/referral/GetMyReferralLink";

export default defineComponent({
  name: "ReferralLinkCard",
  props: {
    franchiseId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: true,
      link: null as MyReferralLinkType | null,
      copied: false,
    };
  },
  watch: {
    franchiseId: {
      immediate: true,
      handler() {
        void this.loadLink();
      },
    },
  },
  methods: {
    async loadLink() {
      this.loading = true;
      try {
        this.link = await new GetMyReferralLink().execute(this.franchiseId || undefined);
      } catch {
        this.link = null;
      } finally {
        this.loading = false;
      }
    },
    async copyLink() {
      if (!this.link?.url) return;
      try {
        await navigator.clipboard.writeText(this.link.url);
        this.copied = true;
        this.$store.dispatch("showSnack", {
          message: "Link de indicação copiado.",
          color: "green",
        });
        window.setTimeout(() => {
          this.copied = false;
        }, 2200);
      } catch {
        this.$store.dispatch("showSnack", {
          message: "Não foi possível copiar o link.",
          color: "red",
        });
      }
    },
  },
});
</script>

<style scoped lang="scss">
.referral-link-card {
  border-radius: 14px;
  border-color: #f0d4da !important;
  background: linear-gradient(135deg, #fff8f9 0%, #ffffff 70%);
}

.referral-link-card__inner {
  display: flex;
  gap: 14px;
  padding: 18px 20px;
}

.referral-link-card__icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 14px rgba(229, 24, 61, 0.12);
  flex-shrink: 0;
}

.referral-link-card__title {
  display: block;
  font-size: 15px;
  color: #1f243f;
}

.referral-link-card__subtitle {
  margin: 4px 0 12px;
  font-size: 13px;
  color: #667085;
}

.referral-link-card__field {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.referral-link-card__url {
  flex: 1;
  min-width: 220px;
  display: block;
  padding: 10px 12px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #eceff5;
  font-size: 12px;
  color: #24305e;
  word-break: break-all;
}

.referral-link-card__code {
  display: inline-block;
  margin-top: 8px;
  font-size: 12px;
  color: #8a94a6;
}

.referral-link-card__error {
  margin: 0;
  font-size: 13px;
  color: #c62828;
}
</style>
